<template>
  <div>
    <div class="row mb-3 pe-4">
      <div class="col-lg-6 col-md-6 col-6 d-flex align-items-center">
        <div class="color-common">
          <h3 class="title-page mb-0 ps-2">POS SETTINGS</h3>
        </div>
      </div>
      <div class="col-lg-6 col-md-6 col-6 d-flex justify-content-end">
        <material-button
          @click="openCopyModal()"
          class="btn-background btn-sm me-2"
          :disabled="!form.branch_id"
        >
          {{ $t("Copy to Branches") }}
        </material-button>
        <material-button @click="updateSettings()" class="btn-background btn-sm">
          {{ $t("Save") }}
        </material-button>
      </div>
    </div>
    <div class="page-header align-items-start min-vh-100">
      <div class="c-container">
        <div class="row">
          <div
            class="col-lg-12 col-md-12 col-12 mx-auto pb-5 mt-2"
            v-if="isLoadData"
          >
            <div class="row card-custom-new mt-3">
              <div class="col-12">
                <div class="d-flex flex-wrap align-items-center" style="gap: 16px">
                  <div class="label-form">Branch</div>
                  <div style="width: 320px; max-width: 100%">
                    <Multiselect
                      :searchable="true"
                      v-model="form.branch_id"
                      :options="branchs"
                      :canClear="false"
                      @change="changeBranch"
                    />
                  </div>
                </div>

                <template v-if="form.branch_id">
                  <div class="tab-list p-0 mt-4">
                    <ul id="pos-settings-tab" class="nav nav-tabs">
                      <li class="nav-item">
                        <a id="nav_item_1" class="nav-link active" @click="changeTab(1)">Charges</a>
                      </li>
                      <li class="nav-item">
                        <a id="nav_item_2" class="nav-link" @click="changeTab(2)">Redeem &amp; BCRS</a>
                      </li>
                      <li class="nav-item">
                        <a id="nav_item_3" class="nav-link" @click="changeTab(3)">Email</a>
                      </li>
                      <li class="nav-item">
                        <a id="nav_item_4" class="nav-link" @click="changeTab(4)">Payment Method</a>
                      </li>
                      <li class="nav-item">
                        <a id="nav_item_5" class="nav-link" @click="changeTab(5)">Discount</a>
                      </li>
                      <li class="nav-item">
                        <a id="nav_item_6" class="nav-link" @click="changeTab(6)">Promotions</a>
                      </li>
                      <li class="nav-item">
                        <a id="nav_item_7" class="nav-link" @click="changeTab(7)">Import / Export</a>
                      </li>
                    </ul>
                  </div>

                  <div v-if="isTabCharges">
                  <!-- Service Charge -->
                  <h5 class="mt-4">Service Charge</h5>
                  <div class="row mt-2">
                    <div class="col-lg-4 col-12 label-form d-flex align-items-center">
                      Rate (%)
                    </div>
                    <div class="col-lg-8 col-12" style="max-width: 300px">
                      <material-input v-model="form.service_charge.rate" type="number" placeholder="0" />
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-lg-4 col-12 label-form d-flex align-items-center">
                      Apply on subtotal after discount
                    </div>
                    <div class="col-lg-8 col-12">
                      <div :class="{ active: isActiveServiceChargeOnDiscounted }" class="toggle_container">
                        <MaterialToggleButton
                          labelEnableText=""
                          labelDisableText=""
                          id="event_handle_service_charge_on_discounted"
                          v-on:change="triggerEventServiceChargeOnDiscounted"
                        />
                      </div>
                    </div>
                  </div>

                  <!-- Takeaway Service Charge -->
                  <h5 class="mt-4">Takeaway Service Charge</h5>
                  <div class="row mt-2">
                    <div class="col-lg-4 col-12 label-form d-flex align-items-center">
                      Enabled
                    </div>
                    <div class="col-lg-8 col-12">
                      <div :class="{ active: isActiveTakeawayServiceCharge }" class="toggle_container">
                        <MaterialToggleButton
                          labelEnableText=""
                          labelDisableText=""
                          id="event_handle_takeaway_service_charge"
                          v-on:change="triggerEventTakeawayServiceCharge"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="row mt-2" v-if="isActiveTakeawayServiceCharge">
                    <div class="col-lg-4 col-12 label-form d-flex align-items-center">
                      Rate (%)
                    </div>
                    <div class="col-lg-8 col-12" style="max-width: 300px">
                      <material-input v-model="form.takeaway_service_charge.rate" type="number" placeholder="0" />
                    </div>
                  </div>
                  <div class="row mt-2" v-if="isActiveTakeawayServiceCharge">
                    <div class="col-lg-4 col-12 label-form d-flex align-items-center">
                      Apply on subtotal after discount
                    </div>
                    <div class="col-lg-8 col-12">
                      <div :class="{ active: isActiveTakeawayServiceChargeOnDiscounted }" class="toggle_container">
                        <MaterialToggleButton
                          labelEnableText=""
                          labelDisableText=""
                          id="event_handle_takeaway_service_charge_on_discounted"
                          v-on:change="triggerEventTakeawayServiceChargeOnDiscounted"
                        />
                      </div>
                    </div>
                  </div>

                  <!-- Cash Rounding -->
                  <h5 class="mt-4">Cash Rounding</h5>
                  <div class="row mt-2">
                    <div class="col-lg-4 col-12 label-form d-flex align-items-center">
                      Mode
                    </div>
                    <div class="col-lg-8 col-12" style="max-width: 300px">
                      <Multiselect
                        :searchable="false"
                        v-model="form.cash_rounding.mode"
                        :options="cash_rounding_modes"
                        :canClear="false"
                      />
                    </div>
                  </div>

                  </div>

                  <div v-if="isTabRedeemBcrs">
                  <!-- Redeem -->
                  <h5 class="mt-4">Redeem</h5>
                  <div class="row mt-2">
                    <div class="col-lg-4 col-12 label-form d-flex align-items-center">
                      Max Deduct Type
                    </div>
                    <div class="col-lg-8 col-12" style="max-width: 300px">
                      <Multiselect
                        :searchable="false"
                        v-model="form.redeem.type"
                        :options="max_deduct_types"
                        :canClear="false"
                      />
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-lg-4 col-12 label-form d-flex align-items-center">
                      Max Deduct Value
                    </div>
                    <div class="col-lg-8 col-12" style="max-width: 300px">
                      <material-input v-model="form.redeem.value" type="number" placeholder="0" />
                    </div>
                  </div>

                  <!-- BCRS -->
                  <h5 class="mt-4">BCRS</h5>
                  <div class="row mt-2">
                    <div class="col-lg-4 col-12 label-form d-flex align-items-center">
                      Enabled
                    </div>
                    <div class="col-lg-8 col-12">
                      <div :class="{ active: isActiveBcrs }" class="toggle_container">
                        <MaterialToggleButton
                          labelEnableText=""
                          labelDisableText=""
                          id="event_handle_bcrs"
                          v-on:change="triggerEventBcrs"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="row mt-2" v-if="isActiveBcrs">
                    <div class="col-lg-4 col-12 label-form d-flex align-items-center">
                      Amount
                    </div>
                    <div class="col-lg-8 col-12" style="max-width: 300px">
                      <material-input v-model="form.bcrs.value" type="number" placeholder="0" />
                    </div>
                  </div>

                  </div>

                  <div v-if="isTabEmail">
                  <!-- Email -->
                  <h5 class="mt-4">Email</h5>
                  <div class="text-sm text-secondary mb-2">
                    Where the end-of-operation report is sent. Send a test after changing the server or credentials.
                  </div>

                  <h6 class="mt-3">Reports by e-mail</h6>
                  <div class="d-flex flex-wrap align-items-center">
                    <div class="d-flex align-items-center label-form me-4">
                      <material-checkbox
                        v-model="form.email.send_reports"
                        :checked="form.email.send_reports"
                        name="send_reports"
                        class="align-items-center px-3"
                      ></material-checkbox>
                      Send reports by e-mail
                    </div>
                    <div class="d-flex align-items-center label-form me-4">
                      <material-checkbox
                        v-model="form.email.send_on_business_day_end"
                        :checked="form.email.send_on_business_day_end"
                        name="send_on_business_day_end"
                        class="align-items-center px-3"
                      ></material-checkbox>
                      Send when the operation (business day) ends
                    </div>
                    <div class="d-flex align-items-center label-form">
                      <material-checkbox
                        v-model="form.email.attach_as_file"
                        :checked="form.email.attach_as_file"
                        name="attach_as_file"
                        class="align-items-center px-3"
                      ></material-checkbox>
                      Attach the report as a file (off = the report is inlined in the message)
                    </div>
                  </div>

                  <h6 class="mt-3">SMTP server</h6>
                  <div class="row mt-2">
                    <div class="col-lg-4 col-12 label-form d-flex align-items-center">SMTP server</div>
                    <div class="col-lg-8 col-12" style="max-width: 400px">
                      <material-input v-model="form.email.smtp_host" type="text" placeholder="smtp.gmail.com" />
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-lg-4 col-12 label-form d-flex align-items-center">Port</div>
                    <div class="col-lg-8 col-12" style="max-width: 200px">
                      <material-input v-model="form.email.smtp_port" type="number" placeholder="587" />
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-lg-4 col-12 label-form d-flex align-items-center">Username</div>
                    <div class="col-lg-8 col-12" style="max-width: 400px">
                      <material-input v-model="form.email.smtp_username" type="text" placeholder="" />
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-lg-4 col-12 label-form d-flex align-items-center">Password</div>
                    <div class="col-lg-8 col-12" style="max-width: 400px">
                      <material-input v-model="form.email.smtp_password" type="password" placeholder="" />
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-lg-4 col-12 label-form d-flex align-items-center"></div>
                    <div class="col-lg-8 col-12">
                      <div class="d-flex align-items-center label-form">
                        <material-checkbox
                          v-model="form.email.smtp_use_ssl"
                          :checked="form.email.smtp_use_ssl"
                          name="smtp_use_ssl"
                          class="align-items-center px-3"
                        ></material-checkbox>
                        Use SSL/TLS (forced on for Gmail)
                      </div>
                    </div>
                  </div>

                  <h6 class="mt-3">Message</h6>
                  <div class="row mt-2">
                    <div class="col-lg-4 col-12 label-form d-flex align-items-center">From address</div>
                    <div class="col-lg-8 col-12" style="max-width: 400px">
                      <material-input v-model="form.email.from_address" type="text" placeholder="blank = the SMTP username" />
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-lg-4 col-12 label-form d-flex align-items-center">From name</div>
                    <div class="col-lg-8 col-12" style="max-width: 400px">
                      <material-input v-model="form.email.from_name" type="text" placeholder="MegaPOS" />
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-lg-4 col-12 label-form d-flex align-items-center">Subject prefix</div>
                    <div class="col-lg-8 col-12" style="max-width: 400px">
                      <material-input v-model="form.email.subject_prefix" type="text" placeholder="MegaPOS" />
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-lg-4 col-12 label-form d-flex align-items-center">Recipients</div>
                    <div class="col-lg-8 col-12" style="max-width: 400px">
                      <material-input v-model="form.email.recipients" type="text" placeholder="boss@example.com; accounts@example.com" />
                    </div>
                  </div>
                  <div class="text-sm text-secondary mt-1">
                    Separate several recipients with a comma or a semicolon.
                  </div>

                  </div>

                  <!-- Payment Method: the tender-screen payment method buttons. A row list, not a
                       fixed set of columns, so it is its own branch-scoped resource
                       (MintyPosPaymentMethod) rather than part of the settings blob above -
                       saved with its own Revert/Add/Save, not the page-wide Save button. -->
                  <div v-if="isTabPaymentMethod">
                  <h5 class="mt-4">Payment Method</h5>
                  <div class="text-sm text-secondary mb-2">
                    Configure the payment methods shown at tender. Drag the handle to reorder — the
                    order here is the button order on the payment screen. Blank-name rows are ignored.
                  </div>
                  <div class="d-flex flex-wrap align-items-center mb-2">
                    <material-button
                      @click="revertPaymentMethods()"
                      class="btn btn-sm btn-background mw-185px me-3"
                    >
                      Revert
                    </material-button>
                    <material-button
                      @click="addPaymentMethodRow()"
                      class="btn btn-sm btn-background mw-185px me-3"
                    >
                      + Add
                    </material-button>
                    <material-button
                      @click="savePaymentMethods()"
                      class="btn btn-sm btn-background mw-185px"
                    >
                      Save
                    </material-button>
                  </div>
                  <div class="table-responsive">
                    <table class="table table-sm align-items-center">
                      <thead>
                        <tr>
                          <th></th>
                          <th class="text-center">#</th>
                          <th>Name</th>
                          <th>ERP Payment Method</th>
                          <th>Bank Code</th>
                          <th>Type</th>
                          <th class="text-center">Receipt Copy</th>
                          <th class="text-center">CMS Rate</th>
                          <th></th>
                        </tr>
                      </thead>
                      <draggable
                        v-if="paymentMethods.length"
                        v-model="paymentMethods"
                        item-key="__key"
                        tag="tbody"
                      >
                        <template #item="{ element, index }">
                          <tr>
                            <td class="text-center">
                              <i class="material-icons css-icon-upload">swap_vert</i>
                            </td>
                            <td class="text-center">{{ index + 1 }}</td>
                            <td>
                              <material-input v-model="element.name" type="text" placeholder="Name" />
                            </td>
                            <td>
                              <material-input v-model="element.erp_payment_method" type="text" placeholder="" />
                            </td>
                            <td>
                              <material-input v-model="element.bank_code" type="text" placeholder="" />
                            </td>
                            <td style="min-width: 180px">
                              <Multiselect
                                :searchable="true"
                                v-model="element.type"
                                :options="paymentMethodTypes"
                                :canClear="false"
                                :append-to-body="true"
                              />
                            </td>
                            <td style="max-width: 100px">
                              <material-input v-model="element.receipt_copy" type="number" placeholder="1" />
                            </td>
                            <td style="max-width: 100px">
                              <material-input v-model="element.cms_rate" type="number" placeholder="0" />
                            </td>
                            <td class="text-center">
                              <i
                                class="material-icons text-danger cursor-pointer"
                                @click="removePaymentMethodRow(index)"
                                >delete</i
                              >
                            </td>
                          </tr>
                        </template>
                      </draggable>
                      <tbody v-else>
                        <tr>
                          <td colspan="9" class="text-center text-secondary">No payment methods yet.</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  </div>

                  <div v-if="isTabDiscount">
                  <!-- Discount -->
                  <h5 class="mt-4">Discount</h5>
                  <div class="text-sm text-secondary mb-2">
                    The 4 discount types the POS terminal's "Choose discount" screen offers, each
                    switchable on its own, plus a per-order cap that applies no matter which type
                    the cashier used.
                  </div>
                  <div class="row mt-2">
                    <div class="col-lg-4 col-12 label-form d-flex align-items-center">
                      Bill Discount (% / $)
                    </div>
                    <div class="col-lg-8 col-12">
                      <div :class="{ active: isActiveBillDiscount }" class="toggle_container">
                        <MaterialToggleButton
                          labelEnableText=""
                          labelDisableText=""
                          id="event_handle_bill_discount"
                          v-on:change="triggerEventBillDiscount"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-lg-4 col-12 label-form d-flex align-items-center">
                      Free Bill (100%)
                    </div>
                    <div class="col-lg-8 col-12">
                      <div :class="{ active: isActiveFreeBill }" class="toggle_container">
                        <MaterialToggleButton
                          labelEnableText=""
                          labelDisableText=""
                          id="event_handle_free_bill"
                          v-on:change="triggerEventFreeBill"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-lg-4 col-12 label-form d-flex align-items-center">
                      Item Discount
                    </div>
                    <div class="col-lg-8 col-12">
                      <div :class="{ active: isActiveItemDiscount }" class="toggle_container">
                        <MaterialToggleButton
                          labelEnableText=""
                          labelDisableText=""
                          id="event_handle_item_discount"
                          v-on:change="triggerEventItemDiscount"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-lg-4 col-12 label-form d-flex align-items-center">
                      Free Item
                    </div>
                    <div class="col-lg-8 col-12">
                      <div :class="{ active: isActiveFreeItem }" class="toggle_container">
                        <MaterialToggleButton
                          labelEnableText=""
                          labelDisableText=""
                          id="event_handle_free_item"
                          v-on:change="triggerEventFreeItem"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-lg-4 col-12 label-form d-flex align-items-center">
                      Max discount per order (%)
                    </div>
                    <div class="col-lg-4 col-12" style="max-width: 300px">
                      <material-input
                        v-model="form.discount.max_percent"
                        type="number"
                        placeholder="0"
                        :disabled="!!form.discount.max_percent_unlimited"
                      />
                    </div>
                    <div class="col-lg-4 col-12">
                      <material-checkbox
                        v-model="form.discount.max_percent_unlimited"
                        :checked="!!form.discount.max_percent_unlimited"
                        value="1"
                        name="discount_max_percent_unlimited"
                        class="align-items-center"
                      >
                        <template v-slot:label>Unlimited</template>
                      </material-checkbox>
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-lg-4 col-12 label-form d-flex align-items-center">
                      Max discount per order ($)
                    </div>
                    <div class="col-lg-4 col-12" style="max-width: 300px">
                      <material-input
                        v-model="form.discount.max_amount"
                        type="number"
                        placeholder="0"
                        :disabled="!!form.discount.max_amount_unlimited"
                      />
                    </div>
                    <div class="col-lg-4 col-12">
                      <material-checkbox
                        v-model="form.discount.max_amount_unlimited"
                        :checked="!!form.discount.max_amount_unlimited"
                        value="1"
                        name="discount_max_amount_unlimited"
                        class="align-items-center"
                      >
                        <template v-slot:label>Unlimited</template>
                      </material-checkbox>
                    </div>
                  </div>

                  </div>

                  <div v-if="isTabPromotions">
                  <pos-promotions-panel
                    :branch-id="form.branch_id"
                    @notify="onPromotionsNotify"
                  ></pos-promotions-panel>
                  </div>

                  <div v-if="isTabImportExport">
                  <!-- Import / Export -->
                  <h5 class="mt-4">Import / Export Settings</h5>
                  <div class="text-sm text-secondary mb-3">
                    Export this branch's POS settings to a JSON file, or import one to apply
                    settings here. Import always shows a preview first — nothing is written until
                    you confirm.
                  </div>

                  <div class="import-export-box">
                    <div class="d-flex align-items-center justify-content-between flex-wrap" style="gap: 12px">
                      <div>
                        <h6 class="mb-1">Export</h6>
                        <div class="text-sm text-secondary">
                          Download this branch's current POS settings as a JSON file.
                        </div>
                      </div>
                      <material-button
                        @click="exportSettingsJson()"
                        class="btn btn-sm btn-background mw-185px"
                      >
                        <i class="material-icons text-sm align-middle me-1">file_download</i>
                        Export Settings
                      </material-button>
                    </div>
                  </div>

                  <div class="import-export-box mt-3">
                    <h6 class="mb-1">Import</h6>
                    <div class="text-sm text-secondary mb-3">
                      Upload a POS settings JSON file exported from this or another branch.
                    </div>

                    <div class="d-flex flex-wrap align-items-center" style="gap: 12px">
                      <material-input
                        hidden
                        type="file"
                        id="file_import_pos_settings_json"
                        name="file_import_pos_settings_json"
                        @change="onFileChange($event)"
                        accept=".json"
                      />
                      <material-button
                        @click="chooseFile()"
                        class="btn btn-sm btn-background mw-185px"
                      >
                        Choose file
                      </material-button>
                      <div class="text-sm" :class="file ? '' : 'text-secondary'">
                        <i class="material-icons text-sm align-middle me-1">description</i>{{ fileName }}
                      </div>
                    </div>
                    <div class="mt-2" v-if="fileError">
                      <span class="is-invalid">{{ fileError }}</span>
                    </div>

                    <div class="d-flex flex-wrap align-items-center mt-3" style="gap: 12px">
                      <material-button
                        @click="previewImport()"
                        class="btn btn-sm btn-background mw-185px"
                        :disabled="!file"
                      >
                        Preview Import
                      </material-button>
                      <material-button
                        @click="confirmImport()"
                        class="btn btn-sm btn-background mw-185px"
                        :disabled="!previewResult"
                      >
                        Confirm Import
                      </material-button>
                      <span class="text-sm text-secondary" v-if="file && !previewResult">
                        Preview is required before you can confirm.
                      </span>
                    </div>
                  </div>

                  <div class="import-export-box mt-3" v-if="previewResult">
                    <div class="d-flex align-items-center justify-content-between flex-wrap mb-1" style="gap: 8px">
                      <h6 class="mb-0">Import Preview</h6>
                      <div class="d-flex flex-wrap" style="gap: 6px">
                        <span v-if="previewResult.changed.length" class="badge badge-sm bg-gradient-info">
                          {{ previewResult.changed.length }} changed
                        </span>
                        <span v-if="previewResult.added.length" class="badge badge-sm bg-gradient-success">
                          {{ previewResult.added.length }} added
                        </span>
                        <span v-if="previewResult.unknown_fields.length" class="badge badge-sm bg-secondary">
                          {{ previewResult.unknown_fields.length }} unknown
                        </span>
                        <span v-if="previewResult.errors.length" class="badge badge-sm bg-danger">
                          {{ previewResult.errors.length }} error(s)
                        </span>
                      </div>
                    </div>
                    <div class="text-sm text-secondary mb-3">
                      {{ previewUnchangedCount }} field(s) already match the file and are not listed.
                    </div>

                    <div v-if="previewResult.changed.length" class="mb-3">
                      <h6 class="text-sm fw-bold mb-2">
                        <i class="material-icons text-sm align-middle text-info me-1">sync_alt</i>Changed
                      </h6>
                      <div class="table-responsive">
                        <table class="table table-sm table-hover preview-table">
                          <thead>
                            <tr>
                              <th class="text-sm ps-0">Setting</th>
                              <th class="text-sm">Change</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(row, index) in previewResult.changed" :key="'changed-' + index">
                              <td class="text-sm ps-0">{{ rowLabel(row) }}</td>
                              <td class="text-sm">
                                <span class="text-secondary text-decoration-line-through">{{ row.current }}</span>
                                <i class="material-icons text-sm align-middle text-secondary mx-1">arrow_forward</i>
                                <span class="fw-bold text-info">{{ row.new }}</span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div v-if="previewResult.added.length" class="mb-3">
                      <h6 class="text-sm fw-bold mb-2">
                        <i class="material-icons text-sm align-middle text-success me-1">add_circle</i>Added
                      </h6>
                      <div class="table-responsive">
                        <table class="table table-sm table-hover preview-table">
                          <tbody>
                            <tr v-for="(row, index) in previewResult.added" :key="'added-' + index">
                              <td class="text-sm ps-0">{{ rowLabel(row) }}</td>
                              <td class="text-sm fw-bold text-success">{{ row.new }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div v-if="previewResult.unknown_fields.length" class="alert alert-secondary py-2 px-3 mb-3">
                      <div class="text-sm fw-bold mb-1">
                        <i class="material-icons text-sm align-middle me-1">help_outline</i>Unknown fields (ignored)
                      </div>
                      <div class="text-sm">
                        Not recognized by this version of POS Settings and will be skipped:
                        {{ previewResult.unknown_fields.join(", ") }}
                      </div>
                    </div>

                    <div v-if="previewResult.errors.length" class="alert alert-danger py-2 px-3 mb-3">
                      <div class="text-sm fw-bold mb-1">
                        <i class="material-icons text-sm align-middle me-1">error_outline</i>Validation errors
                      </div>
                      <div class="text-sm" v-for="(err, index) in previewResult.errors" :key="'error-' + index">
                        {{ rowLabel(err) }} — {{ err.error }}
                      </div>
                    </div>

                    <div v-if="previewResult.payment_methods" class="alert alert-warning py-2 px-3 mb-3">
                      <div class="text-sm fw-bold mb-1">
                        <i class="material-icons text-sm align-middle me-1">warning</i>Payment methods will be replaced
                      </div>
                      <div class="text-sm">
                        This branch has {{ previewResult.payment_methods.current_count }} payment method(s) now.
                        The file has {{ previewResult.payment_methods.incoming_count }}. Importing will replace
                        this branch's whole payment method list with the file's — this cannot be undone.
                      </div>
                    </div>

                    <div
                      v-if="!previewResult.changed.length && !previewResult.added.length && !previewResult.unknown_fields.length && !previewResult.errors.length && !previewResult.payment_methods"
                      class="alert alert-success py-2 px-3 mb-0"
                    >
                      <i class="material-icons text-sm align-middle me-1">check_circle</i>
                      Everything in this file already matches the branch's current settings.
                    </div>
                  </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
        <div class="position-fixed top-1 end-1 z-index-2 message-success">
          <material-snackbar
            v-if="snackbar === 'danger' || snackbar === 'success'"
            title=""
            date=""
            :description="message"
            :icon="{ component: 'campaign', color: 'white' }"
            :color="snackbar"
            :close-handler="closeSnackbar"
          />
        </div>
        <material-loading :active="loaderActive" />
      </div>
    </div>

    <copy-pos-settings-to-branches
      :key-reload="copyKeyReload"
      :source-branch-id="form.branch_id"
      :source-branch-name="selectedBranchName"
      @copied="onCopied"
      @close-copy-pos-settings="closeCopyModal"
    />

    <!-- POST form submit so the browser saves the response as a file; the token travels in the
         body, the same pattern used by Setting -> Export/Import. -->
    <form :action="`${actionDownload}/merchant/pos-settings/export-json`" method="POST">
      <input type="hidden" name="merchantId" :value="merchantIdExport" />
      <input type="hidden" name="merchant_code" :value="merchantCodeExport" />
      <input type="hidden" name="branch_id" :value="form.branch_id" />
      <input type="hidden" name="token" :value="token" />
      <input id="exportPosSettingsJson" type="submit" class="d-none" />
    </form>
  </div>
</template>

<script>
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import MaterialLoading from "@/components/MaterialLoading.vue";
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialInput from "@/components/MaterialInput.vue";
import MaterialCheckbox from "@/components/MaterialCheckbox.vue";
import MaterialToggleButton from "@/components/MaterialToggleButton.vue";
import CopyPosSettingsToBranches from "@/components/CopyPosSettingsToBranches.vue";
import PosPromotionsPanel from "@/components/PosPromotionsPanel.vue";
import $ from "jquery";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
import draggable from "vuedraggable";
import TestService from "../../../services/test.service";
import SettingPosService from "../../../services/settingPos.service";
import TokenService from "../../../services/token.service";

// Fixed set of payment types an operator can assign to a payment mode.
const PAYMENT_TYPES = [
  "Cash", "Credit Card", "Credits", "Check", "Smart Card", "Cash Card", "Flash Pay",
  "NETS", "Contactless NETS", "QR NETS", "Non-Sales Voucher", "NFC", "Sands Rewards",
  "Hidden", "Paywave", "UnionPay", "Minty", "Stripe VISA/MASTER", "Stripe AMEX",
  "Stripe Paynow", "Grab", "Panda", "Deliveroo", "Malls", "Others", "Voucher", "KPay",
  "MintyDirectDeduction", "AllInPayCP", "AllinPayQR",
  // Airwallex: card-present on the POS terminal, and PayNow QR shown on this screen.
  "AirwallexTerminal", "AirwallexPayNow",
];

export default {
  name: "PosSettingGeneral",
  components: {
    MaterialSnackbar,
    MaterialLoading,
    MaterialButton,
    MaterialInput,
    MaterialCheckbox,
    MaterialToggleButton,
    CopyPosSettingsToBranches,
    PosPromotionsPanel,
    Multiselect,
    draggable,
  },
  data() {
    return {
      message: "",
      snackbar: null,
      loaderActive: false,
      isLoadData: true,
      isTabCharges: true,
      isTabRedeemBcrs: false,
      isTabEmail: false,
      isTabPaymentMethod: false,
      isTabDiscount: false,
      isTabPromotions: false,
      isTabImportExport: false,
      form: {
        branch_id: 0,
        service_charge: { rate: 0, on_discounted_subtotal: 0 },
        takeaway_service_charge: { enabled: 0, rate: 0, on_discounted_subtotal: 0 },
        cash_rounding: { mode: "off" },
        redeem: { type: 1, value: 0 },
        bcrs: { enabled: 0, value: 0 },
        email: {
          send_reports: 0,
          send_on_business_day_end: 1,
          attach_as_file: 1,
          smtp_host: "",
          smtp_port: 587,
          smtp_username: "",
          smtp_password: "",
          smtp_use_ssl: 1,
          from_address: "",
          from_name: "MegaPOS",
          subject_prefix: "MegaPOS",
          recipients: "",
        },
        discount: {
          bill_discount: 1,
          free_bill: 1,
          item_discount: 1,
          free_item: 1,
          max_percent_unlimited: 1,
          max_percent: 0,
          max_amount_unlimited: 1,
          max_amount: 0,
        },
      },
      branchs: [],
      isActiveServiceChargeOnDiscounted: false,
      isActiveTakeawayServiceCharge: false,
      isActiveTakeawayServiceChargeOnDiscounted: false,
      isActiveBcrs: false,
      isActiveBillDiscount: false,
      isActiveFreeBill: false,
      isActiveItemDiscount: false,
      isActiveFreeItem: false,
      paymentMethods: [],
      paymentMethodKeySeq: 0,
      paymentMethodTypes: PAYMENT_TYPES.map((type) => ({ value: type, label: type })),
      cash_rounding_modes: [
        { value: "off", label: "Off" },
        { value: "nearest_5", label: "Nearest 5c" },
        { value: "round_up_5", label: "Round up to 5c" },
        { value: "round_down_5", label: "Round down to 5c" },
        { value: "nearest_10", label: "Nearest 10c" },
      ],
      max_deduct_types: [
        { value: 1, label: "Percent" },
        { value: 2, label: "Amount" },
      ],
      groupOptions: [
        { key: "service_charge", label: "Service Charge" },
        { key: "takeaway_service_charge", label: "Takeaway Service Charge" },
        { key: "cash_rounding", label: "Cash Rounding" },
        { key: "redeem", label: "Redeem" },
        { key: "bcrs", label: "BCRS" },
        { key: "email", label: "Email" },
        { key: "discount", label: "Discount" },
      ],
      file: null,
      fileName: "No file chosen",
      fileError: "",
      previewResult: null,
      copyKeyReload: "0",
      actionDownload: process.env.VUE_APP_BASE_URL,
      token: TokenService.getLocalAccessToken(),
      merchantIdExport: localStorage.getItem("MERCHANT_ID", ""),
      merchantCodeExport: localStorage.getItem("MERCHANT_CODE", ""),
    };
  },
  computed: {
    selectedBranchName() {
      const found = this.branchs.find((b) => b.value === this.form.branch_id);
      return found ? found.label : "";
    },

    previewUnchangedCount() {
      return this.previewResult ? this.previewResult.unchanged.length : 0;
    },
  },
  created() {
    this.getBranches();
  },
  methods: {
    resetTabs() {
      this.isTabCharges = false;
      this.isTabRedeemBcrs = false;
      this.isTabEmail = false;
      this.isTabPaymentMethod = false;
      this.isTabDiscount = false;
      this.isTabPromotions = false;
      this.isTabImportExport = false;
    },

    changeTab(type) {
      this.resetTabs();
      $("#pos-settings-tab .nav-link").removeClass("active");
      $("#nav_item_" + type).addClass("active");
      if (type == 1) {
        this.isTabCharges = true;
      } else if (type == 2) {
        this.isTabRedeemBcrs = true;
      } else if (type == 3) {
        this.isTabEmail = true;
      } else if (type == 4) {
        this.isTabPaymentMethod = true;
      } else if (type == 5) {
        this.isTabDiscount = true;
      } else if (type == 6) {
        this.isTabPromotions = true;
      } else if (type == 7) {
        this.isTabImportExport = true;
      }
    },

    getBranches() {
      this.isLoadData = false;
      this.showLoader();
      TestService.getBranches().then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.branchs = response.data.data;
            this.isLoadData = true;
            if (this.branchs.length > 0) {
              this.changeBranch(this.branchs[0].value);
            }
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = this.errorMessage(error);
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },

    changeBranch(id) {
      this.form.branch_id = id;
      this.previewResult = null;
      this.file = null;
      this.fileName = "No file chosen";
      this.fileError = "";
      this.showLoader();
      SettingPosService.getSettings(id).then(
        (response) => {
          if (response.data.result.isSuccess) {
            const data = response.data.data;
            this.applySettings(data.settings || {});
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = this.errorMessage(error);
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
      this.getPaymentMethods();
    },

    keyedPaymentMethod(paymentMethod) {
      this.paymentMethodKeySeq += 1;
      return { ...paymentMethod, __key: "pm-" + this.paymentMethodKeySeq };
    },

    getPaymentMethods() {
      SettingPosService.getPaymentMethods(this.form.branch_id).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.paymentMethods = (response.data.data || []).map((pm) =>
              this.keyedPaymentMethod(pm)
            );
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
        },
        (error) => {
          this.snackbar = "danger";
          this.message = this.errorMessage(error);
          this.setTimeOutNotification();
        }
      );
    },

    addPaymentMethodRow() {
      this.paymentMethods.push(
        this.keyedPaymentMethod({
          id: 0,
          name: "",
          erp_payment_method: "",
          bank_code: "",
          image: "",
          type: "Cash",
          receipt_copy: 1,
          cms_rate: 0,
          status: 1,
        })
      );
    },

    removePaymentMethodRow(index) {
      this.paymentMethods.splice(index, 1);
    },

    revertPaymentMethods() {
      this.getPaymentMethods();
    },

    savePaymentMethods() {
      this.showLoader();

      SettingPosService.savePaymentMethods({
        branch_id: this.form.branch_id,
        items: this.paymentMethods,
      }).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.paymentMethods = (response.data.data || []).map((pm) =>
              this.keyedPaymentMethod(pm)
            );
            this.snackbar = "success";
            this.message = "Payment methods saved";
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
          }
          this.hideLoader();
          this.setTimeOutNotification();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = this.errorMessage(error);
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },

    applySettings(settings) {
      const sc = settings.service_charge || {};
      this.form.service_charge.rate = sc.rate ?? 0;
      this.form.service_charge.on_discounted_subtotal = sc.on_discounted_subtotal ? 1 : 0;
      this.isActiveServiceChargeOnDiscounted = !!sc.on_discounted_subtotal;

      const tsc = settings.takeaway_service_charge || {};
      this.isActiveTakeawayServiceCharge = !!tsc.enabled;
      this.form.takeaway_service_charge.enabled = tsc.enabled ? 1 : 0;
      this.form.takeaway_service_charge.rate = tsc.rate ?? 0;
      this.form.takeaway_service_charge.on_discounted_subtotal = tsc.on_discounted_subtotal ? 1 : 0;
      this.isActiveTakeawayServiceChargeOnDiscounted = !!tsc.on_discounted_subtotal;

      const cr = settings.cash_rounding || {};
      this.form.cash_rounding.mode = cr.mode || "off";

      const redeem = settings.redeem || {};
      this.form.redeem.type = redeem.type ?? 1;
      this.form.redeem.value = redeem.value ?? 0;

      const bcrs = settings.bcrs || {};
      this.isActiveBcrs = !!bcrs.enabled;
      this.form.bcrs.enabled = bcrs.enabled ? 1 : 0;
      this.form.bcrs.value = bcrs.value ?? 0;

      const email = settings.email || {};
      this.form.email.send_reports = email.send_reports ? 1 : 0;
      this.form.email.send_on_business_day_end = email.send_on_business_day_end ? 1 : 0;
      this.form.email.attach_as_file = email.attach_as_file ? 1 : 0;
      this.form.email.smtp_host = email.smtp_host || "";
      this.form.email.smtp_port = email.smtp_port || 587;
      this.form.email.smtp_username = email.smtp_username || "";
      this.form.email.smtp_password = email.smtp_password || "";
      this.form.email.smtp_use_ssl = email.smtp_use_ssl ? 1 : 0;
      this.form.email.from_address = email.from_address || "";
      this.form.email.from_name = email.from_name || "MegaPOS";
      this.form.email.subject_prefix = email.subject_prefix || "MegaPOS";
      this.form.email.recipients = email.recipients || "";

      const discount = settings.discount || {};
      this.isActiveBillDiscount = !!discount.bill_discount;
      this.form.discount.bill_discount = discount.bill_discount ? 1 : 0;
      this.isActiveFreeBill = !!discount.free_bill;
      this.form.discount.free_bill = discount.free_bill ? 1 : 0;
      this.isActiveItemDiscount = !!discount.item_discount;
      this.form.discount.item_discount = discount.item_discount ? 1 : 0;
      this.isActiveFreeItem = !!discount.free_item;
      this.form.discount.free_item = discount.free_item ? 1 : 0;
      this.form.discount.max_percent_unlimited = discount.max_percent_unlimited ? 1 : 0;
      this.form.discount.max_percent = discount.max_percent ?? 0;
      this.form.discount.max_amount_unlimited = discount.max_amount_unlimited ? 1 : 0;
      this.form.discount.max_amount = discount.max_amount ?? 0;
    },

    updateSettings() {
      this.showLoader();

      SettingPosService.updateSettings(this.form).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.snackbar = "success";
            this.message = "Save success";
            this.setTimeOutNotification();
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = this.errorMessage(error);
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },

    triggerEventServiceChargeOnDiscounted(value) {
      if (typeof value == "boolean") {
        this.isActiveServiceChargeOnDiscounted = !this.isActiveServiceChargeOnDiscounted;
        this.form.service_charge.on_discounted_subtotal = this.isActiveServiceChargeOnDiscounted ? 1 : 0;
      }
    },

    triggerEventTakeawayServiceCharge(value) {
      if (typeof value == "boolean") {
        this.isActiveTakeawayServiceCharge = !this.isActiveTakeawayServiceCharge;
        this.form.takeaway_service_charge.enabled = this.isActiveTakeawayServiceCharge ? 1 : 0;
      }
    },

    triggerEventTakeawayServiceChargeOnDiscounted(value) {
      if (typeof value == "boolean") {
        this.isActiveTakeawayServiceChargeOnDiscounted = !this.isActiveTakeawayServiceChargeOnDiscounted;
        this.form.takeaway_service_charge.on_discounted_subtotal = this.isActiveTakeawayServiceChargeOnDiscounted
          ? 1
          : 0;
      }
    },

    triggerEventBcrs(value) {
      if (typeof value == "boolean") {
        this.isActiveBcrs = !this.isActiveBcrs;
        this.form.bcrs.enabled = this.isActiveBcrs ? 1 : 0;
      }
    },

    triggerEventBillDiscount(value) {
      if (typeof value == "boolean") {
        this.isActiveBillDiscount = !this.isActiveBillDiscount;
        this.form.discount.bill_discount = this.isActiveBillDiscount ? 1 : 0;
      }
    },

    triggerEventFreeBill(value) {
      if (typeof value == "boolean") {
        this.isActiveFreeBill = !this.isActiveFreeBill;
        this.form.discount.free_bill = this.isActiveFreeBill ? 1 : 0;
      }
    },

    triggerEventItemDiscount(value) {
      if (typeof value == "boolean") {
        this.isActiveItemDiscount = !this.isActiveItemDiscount;
        this.form.discount.item_discount = this.isActiveItemDiscount ? 1 : 0;
      }
    },

    triggerEventFreeItem(value) {
      if (typeof value == "boolean") {
        this.isActiveFreeItem = !this.isActiveFreeItem;
        this.form.discount.free_item = this.isActiveFreeItem ? 1 : 0;
      }
    },

    exportSettingsJson() {
      $("#exportPosSettingsJson").click();
    },

    chooseFile() {
      $("#file_import_pos_settings_json").click();
    },

    onFileChange(event) {
      const file = event.target.files[0];

      this.previewResult = null;
      this.fileError = "";

      if (!file) {
        this.file = null;
        this.fileName = "No file chosen";
        return;
      }

      if (!file.name.toLowerCase().endsWith(".json")) {
        this.file = null;
        this.fileName = "No file chosen";
        this.fileError = "Only .json files exported from POS Settings can be imported.";
        return;
      }

      this.file = file;
      this.fileName = file.name;
    },

    formData() {
      const form = new FormData();
      form.append("file_import", this.file);
      form.append("branch_id", this.form.branch_id);
      return form;
    },

    valid() {
      this.fileError = this.file ? "" : "Choose a .json file to import.";
      return !this.fileError;
    },

    previewImport() {
      if (!this.valid()) {
        return;
      }

      this.showLoader();

      SettingPosService.importSettingsJsonPreview(this.formData()).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.previewResult = response.data.data;
          } else {
            this.previewResult = null;
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.previewResult = null;
          this.snackbar = "danger";
          this.message = this.errorMessage(error);
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },

    confirmImport() {
      // The button is disabled until a preview exists, but guard here too in case it is clicked
      // programmatically or the disabled state has not re-rendered yet.
      if (!this.previewResult || !this.valid()) {
        return;
      }

      this.showLoader();

      SettingPosService.importSettingsJson(this.formData()).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.previewResult = null;
            this.snackbar = "success";
            this.message = "Settings imported.";
            this.setTimeOutNotification();
            this.changeBranch(this.form.branch_id);
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = this.errorMessage(error);
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },

    rowLabel(row) {
      const group = this.groupOptions.find((g) => g.key === row.group);
      return (group ? group.label : row.group) + " — " + this.fieldLabel(row.field);
    },

    fieldLabel(field) {
      return String(field)
        .split("_")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    },

    openCopyModal() {
      if (!this.form.branch_id) {
        return;
      }

      this.copyKeyReload = String(Date.now());
      this.$nextTick(() => {
        $("#show-modal-copy-pos-settings").click();
      });
    },

    closeCopyModal() {
      $("#hide-modal-copy-pos-settings").click();
    },

    onCopied(result) {
      $("#hide-modal-copy-pos-settings").click();
      const count = result && result.destinations
        ? result.destinations.filter((d) => d.status === "applied").length
        : 0;
      this.snackbar = "success";
      this.message = "Copied POS settings to " + count + " branch(es).";
      this.setTimeOutNotification();
    },

    errorMessage(error) {
      const result = error && error.response && error.response.data ? error.response.data.result : null;
      return result && result.message ? result.message : String(error);
    },

    onPromotionsNotify(type, message) {
      this.snackbar = type;
      this.message = message;
      this.setTimeOutNotification();
    },

    closeSnackbar() {
      this.snackbar = null;
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },

    showLoader() {
      this.loaderActive = true;
    },

    hideLoader() {
      this.loaderActive = false;
    },
  },
};
</script>

<style scoped>
.c-container {
  width: 100%;
  max-width: 100%;
  padding-left: 25px;
  padding-right: 25px;
}

.multiselect {
  max-width: 500px !important;
  margin-left: 0;
}

.preview-table td,
.preview-table th {
  vertical-align: middle;
}

.import-export-box {
  border: 1px solid #e2e2e2;
  border-radius: 10px;
  padding: 20px;
  background: #fff;
}

.tab-list {
  overflow-x: auto;
  padding-bottom: 5px !important;
}

.tab-list::-webkit-scrollbar {
  height: 7px;
}

.tab-list::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.tab-list::-webkit-scrollbar-thumb {
  background: #888;
}

.tab-list::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.tab-list #pos-settings-tab {
  flex-wrap: unset !important;
  border-bottom: 1px solid #e9ecef;
}

.tab-list #pos-settings-tab li.nav-item {
  min-width: fit-content;
}

.tab-list #pos-settings-tab li a.nav-link {
  border: none;
  border-bottom: 3px solid transparent;
  border-radius: 8px 8px 0 0;
  color: #67748e;
  font-weight: 600;
  font-size: 0.925rem;
  padding: 10px 20px;
  cursor: pointer;
  background-color: unset;
  transition: color 0.15s ease, border-color 0.15s ease, background-color 0.15s ease;
}

.tab-list #pos-settings-tab li a.nav-link:hover {
  color: #133067;
  background-color: #f5f7fb;
}

.tab-list #pos-settings-tab li a.active,
.tab-list #pos-settings-tab li a.nav-link.active:hover {
  border: none;
  border-bottom: 3px solid #133067;
  color: #133067;
  background-color: unset;
}
</style>
